import { registerPlugin } from '@capacitor/core';

const InitManager = registerPlugin<any>('InitManager');

export default InitManager;
